/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ClientLoyaltyProgramDto } from './clientLoyaltyProgramDto';


export interface CustomerLoyaltyDto { 
    userId?: number;
    email?: string;
    language?: string;
    loyaltyId?: number;
    cardNumber?: string;
    points?: number;
    precisePoints?: number;
    lastUpdate?: string;
    status?: CustomerLoyaltyDto.StatusEnum;
    loyaltyProgram?: ClientLoyaltyProgramDto;
    ended?: boolean;
}
export namespace CustomerLoyaltyDto {
    export type StatusEnum = 'ACTIVE' | 'BLOCKED';
    export const StatusEnum = {
        Active: 'ACTIVE' as StatusEnum,
        Blocked: 'BLOCKED' as StatusEnum
    };
}


